import type {
  BlockTemplateType,
  CheckoutBlockType,
} from "@intelligems/ig-types/dtos/checkout-blocks";

/** The template a new block of this type starts from. */
export const defaultTemplateFor = (
  blockType: CheckoutBlockType
): BlockTemplateType =>
  blockType === "trustBadge"
    ? "badgeTiles"
    : blockType === "timer"
      ? "textCountdown"
      : blockType === "shippingProgressBar"
        ? "minimal"
        : blockType === "faqs"
          ? "faqsAccordion"
          : "productTiles";
